export const data = [
  {
    value: 4,
    name: '上海',
    selected: false
  },
  {
    value: 4,
    name: '云南',
    selected: false
  },
  {
    value: 3,
    name: '内蒙古',
    selected: false
  },
  {
    value: 5,
    name: '北京',
    selected: false
  },
  {
    value: 3,
    name: '吉林',
    selected: false
  },
  {
    value: 7,
    name: '四川',
    selected: false
  },
  {
    value: 3,
    name: '天津',
    selected: false
  },
  {
    value: 1,
    name: '宁夏',
    selected: false
  },
  {
    value: 4,
    name: '安徽',
    selected: false
  },
  {
    value: 5,
    name: '山东',
    selected: false
  },
  {
    value: 1,
    name: '山西',
    selected: false
  },
  {
    value: 8,
    name: '广东',
    selected: false
  },
  {
    value: 3,
    name: '广西',
    selected: false
  },
  {
    value: 2,
    name: '新疆',
    selected: false
  },
  {
    value: 9,
    name: '江苏',
    selected: false
  },
  {
    value: 2,
    name: '江西',
    selected: false
  },
  {
    value: 4,
    name: '河北',
    selected: false
  },
  {
    value: 4,
    name: '河南',
    selected: false
  },
  {
    value: 4,
    name: '浙江',
    selected: false
  },
  {
    value: 1,
    name: '海南',
    selected: false
  },
  {
    value: 8,
    name: '湖北',
    selected: false
  },
  {
    value: 3,
    name: '湖南',
    selected: false
  },
  {
    value: 1,
    name: '甘肃',
    selected: false
  },
  {
    value: 2,
    name: '福建',
    selected: false
  },
  {
    value: 1,
    name: '西藏',
    selected: false
  },
  {
    value: 2,
    name: '贵州',
    selected: false
  },
  {
    value: 5,
    name: '辽宁',
    selected: false
  },
  {
    value: 3,
    name: '重庆',
    selected: false
  },
  {
    value: 3,
    name: '陕西',
    selected: false
  },
  {
    value: 1,
    name: '青海',
    selected: false
  },
  {
    value: 4,
    name: '黑龙江',
    selected: false
  }
]

export const options = {
  backgroundColor: '#fff',
  tooltip: {
    trigger: 'item'
  },
  // 游标
  visualMap: {
    // orient: 'horizontal', //横置
    type: 'continuous',
    itemWidth: 16,
    itemHeight: 120,
    text: ['高', '低'],
    showLabel: true,
    seriesIndex: [0],
    min: 0,
    max: 25,
    calculable: true, //开启游标
    // left: 50,
    // bottom: 30,
    inRange: {
      color: [
        '#8ED861',
        '#85CE4E',
        '#EED000',
        '#EEAE00',
        '#209FA9',
        '#F5903D',
        '#EE8C00',
        '#EE3B3B'
      ]
    },
    textStyle: {
      color: '#ffffff',
      fontSize: 14
    }
  },

  legend: {
    show: false,
    orient: 'vertical',
    // top: 'right',
    // left: 'bottom',
    // data: ['TOP100地区分布'],
    textStyle: {
      //图例文字的样式
      color: '#333',
      fontSize: 12
    }
  },
  series: [
    {
      name: 'TOP100地区分布',
      type: 'map',
      mapType: 'china',
      roam: false,
      showLegendSymbol: false, //去掉指示点
      itemStyle: {
        normal: {
          borderWidth: 1, //区域边框宽度
          borderColor: '#00a6dc', //区域边框颜色
          areaColor: '#224E7F', //区域颜色
          label: {
            show: false, //是否显示各省名称
            textStyle: {
              color: '#ff5500' //显示各省名称颜色
            }
          }
        },
        emphasis: {
          areaColor: '#67ca4d', //区域颜色，鼠标悬停颜色
          label: {
            show: true, //鼠标悬浮时是否显示各省名称
            textStyle: {
              color: '#fdf1f6' //鼠标悬浮时显示各省名称的颜色
            }
          }
        }
      },
      data: []
    }
  ]
}
